let language = {
    THIRD_PARTY_HAVE_ACCOUNT_TEXT: "如果您有Google账户，您也可以使用这些账户登录{{appName}}",
    
    THIRD_PARTY_SOCIAL_TYPE_GOOGLE: "Google",
    THIRD_PARTY_OR_TEXT: "或",
};

export { language }